import Pagination from "@/types/Pagination.interface"
import Person from "@/types/Person.interface"
import { PersonParams } from "@/types/PaginationParams.interface"

interface State {
    personsAutocompleteList: Person[]
    personsAutocompleteLastPage: number
    personsAutocompleteNextPage: number
}

const defaults = () => {
    return {
        personsAutocompleteList: null,
        personsAutocompleteLastPage: null,
        personsAutocompleteNextPage: null
    }
}

export default {
    state: defaults(),
    mutations: {
        personsAutocompletePush (state: State, persons: Person[]): void {
            //  Update the state
            state.personsAutocompleteList = window.removeDuplicatesById(state.personsAutocompleteList, persons)
        },
        personsAutocompletePaginationPush (state: State, page: Pagination): void {
            //  If this is page one, reset the the channels list
            if (page.current_page === 1) state.personsAutocompleteList = []

            state.personsAutocompleteLastPage = page.last_page
            state.personsAutocompleteNextPage = page.current_page + 1
        },
        personsAutocompleteRemove (state: State, ids: number[]): void {
            //  Get our current list of persons
            const persons = state.personsAutocompleteList

            //  If no persons, do nothing
            if (!persons) return

            //  Else, filter our our removed ids
            const filtered = persons.filter(x => !ids.includes(x.id))

            //  Set our persons to the filtered list
            state.personsAutocompleteList = filtered
        },
        personsAutocompleteSync (state: State, persons: Person[]): void {
            state.personsAutocompleteList = window.removeDuplicatesById(state.personsAutocompleteList, persons)
        },
        personsAutocompleteReset (state: State): void {
            Object.assign(state, defaults())
        }
    },
    actions: {
        personsAutocompletePaginate ({ commit, getters }, params: PersonParams): Promise<void> {
            //  Assemble the API endpoint
            const url = `${getters.api}/persons?${window.toUrlParams(params)}`

            //  Send the request
            return window.axios.get(url).then(response => {
                //  Update our persons autocomplete pagination
                commit('personsAutocompletePaginationPush', response.data)

                //  Update our persons autocomplete list
                commit('personsAutocompletePush', response.data.data)

                //  Push to the global dataset
                commit('personsPush', response.data.data)
            }).catch(() => null)
        },
    },
    getters: {
        personsAutocompleteList (state: State): Person[] {
            return state.personsAutocompleteList
        },
        personsAutocompleteLastPage (state: State): number {
            return state.personsAutocompleteLastPage
        },
        personsAutocompleteNextPage (state: State): number {
            return state.personsAutocompleteNextPage
        }
    }
}